import {css} from 'lit';
export const styles = css`:host {
  --avatar-border: 4px solid var(--contrast-light);
  --avatars-overlap: 16px;
  --avatars-direction: row;
  --label-bg: transparent;
  --label-text: var(--text-primary);
  --label-font-size: var(--font-size-base);
  --label-font-weight: var(--body-font-weight);
  --label-border-radius: 0;
  --label-padding: 0;
  --host-direction: row;
  --width: auto;

  display: flex;
  align-items: center;
  flex-direction: var(--host-direction);
  width: var(--width);
  min-height: 40px;
  min-height: var(--avatar-size, 40px);
}

a {
  flex-basis: 100%;
  display: flex;
  align-items: center;
  flex-direction: var(--host-direction);
  color: var(--label-text);
  transition: opacity var(--transition-duration) var(--transition-timing);
}

@media (hover: hover) {

a {
    cursor: pointer
}

    a:hover {
      opacity: 0.8;
      color: var(--label-text);
    }
  }

a:active {
    opacity: 0.9;
    color: var(--label-text);
  }

.avatar-list {
  display: flex;
  flex-direction: var(--avatars-direction);
  padding-left: var(
    --avatars-overlap
  ); /* Imaginary padding - creates space for first child to move left */
}

ef-avatar {
  border: var(--avatar-border);
  margin-left: calc(-1 * var(--avatars-overlap));
}

.label {
  padding: var(--label-padding);
  background-color: var(--label-bg);
  color: var(--label-text);
  font-size: var(--label-font-size);
  font-weight: var(--label-font-weight);
  border-radius: var(--label-border-radius);
  white-space: nowrap;
}
`;
export default styles;
